import './App.css'
import Pages from "@/pages/index.jsx"
import { Toaster } from 'sonner'
import SiteNotice from '@/components/SiteNotice'
import { BrowserRouter } from 'react-router-dom'

function App() {
  return (
    <BrowserRouter>
      <Pages />
      <SiteNotice />
      <Toaster position="bottom-right" theme="dark" />
    </BrowserRouter>
  )
}

export default App  